module.exports = __webpack_public_path__ + "static/JetBrainsMono-Bold-c318a45b45be019ffdeb8c9ac6a41283.woff2";